import $ from 'jquery';
import React from 'react';
import { string, shape, arrayOf, func, bool } from 'prop-types';

export default class MultiCheckboxFilter extends React.Component {
    constructor(props) {
        super(props);

        this.handleTitleClick = this.handleTitleClick.bind(this);
    }

    // @NOTE - right now only the multi checkbox requires the isFocused state,
    // if in the future this is required by other filters also then we should push this function up a level to Filters
    // go a step further and make all filter components call the toggleFocus function when they are in focus
    componentDidMount() {
        $('body').click(e => {
            const clickedOn = $(e.target);
            const rootClass = '.multi-checkbox-filter';
            if (!clickedOn.hasClass(rootClass) && !clickedOn.parents(rootClass).length) {
                this.props.toggleFocus.call(this, null, null);
            }
        });
    }

    handleTitleClick() {
        if (this.props.isFocused) {
            this.props.toggleFocus.call(this, null);
        } else {
            this.props.toggleFocus.call(this, this.props.filter);
        }
    }

    render() {
        const listId = `multi-checkbox-${this.props.filter.code}`;
        return (
            <div className={`multi-checkbox-filter ${this.props.isFocused ? 'is-open' : ''} ${this.props.classModifier}`}>
                <div className="select-wrapper">
                    <div className="input-wrapper">
                        <div
                            className="select"
                            onClick={this.handleTitleClick}
                            onKeyPress={this.handleTitleClick}
                            role="combobox"
                            aria-controls={listId}
                            aria-expanded={this.props.isFocused ? 'true' : 'false'}
                            tabIndex="0"
                        >
                            <p className="multi-checkbox-filter-title-text">{this.props.filter.label}</p>
                        </div>
                    </div>
                </div>
                <div className="multi-checkbox-filter-panel" id={listId}>
                    <div className="checkbox-wrapper" id={listId}>
                        <div className="input-wrapper">
                            {this.props.filter.values.map(value => (
                                <div className="checkbox-item" key={value}>
                                    <input
                                        id={value}
                                        onChange={e => this.props.toggleFilters(e, this.props.filter, value)}
                                        onKeyPress={e => this.props.toggleFilters(e, this.props.filter, value)}
                                        type="checkbox"
                                        checked={this.props.selectedItems.includes(value) ? 'checked' : ''}
                                    />
                                    <label htmlFor={value}>{value}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MultiCheckboxFilter.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    filter: shape({
        code: string.isRequired,
        label: string.isRequired,
        values: arrayOf(string).isRequired
    }).isRequired,
    classModifier: string,
    selectedItems: arrayOf(string).isRequired,
    toggleFilters: func.isRequired,
    isFocused: bool.isRequired,
    toggleFocus: func.isRequired
    /* eslint-enable react/no-typos */
};

MultiCheckboxFilter.defaultProps = { classModifier: '' };

